import { isMGAdviceBrandingEnabled } from './featureFlags';

/** Brand name before 16 Oct 2026 */
export const BRAND_OLD = 'M&G Wealth Advice';

/** Brand name from 16 Oct 2026 onwards */
export const BRAND_NEW = 'M&G Advice';

/** Legal entity name before 16 Oct 2026 */
export const BRAND_OLD_LIMITED = 'M&G Wealth Advice Limited';

/** Legal entity name from 16 Oct 2026 onwards */
export const BRAND_NEW_LIMITED = 'M&G Advice Partners Limited';

/**
 * Returns the active brand name based on the current date feature flag.
 * - Before 16 Oct 2026 → "M&G Wealth Advice"
 * - On/after 16 Oct 2026 → "M&G Advice"
 */
export const getBrandName = (): string =>
  isMGAdviceBrandingEnabled() ? BRAND_NEW : BRAND_OLD;

/**
 * Returns the active legal entity name based on the current date feature flag.
 * - Before 16 Oct 2026 → "M&G Wealth Advice Limited"
 * - On/after 16 Oct 2026 → "M&G Advice Partners Limited"
 */
export const getBrandNameLimited = (): string =>
  isMGAdviceBrandingEnabled() ? BRAND_NEW_LIMITED : BRAND_OLD_LIMITED;

/**
 * Replaces all occurrences of the old brand names with the new ones
 * in a decoded content string when the branding feature flag is active.
 *
 * NOTE: "M&G Wealth Advice Limited" is replaced first (more specific match)
 * before the general "M&G Wealth Advice" → "M&G Advice" swap, to ensure
 * the legal entity name maps to "M&G Advice Partners Limited" correctly.
 *
 * This is applied to the AEM-sourced content JSON string before it is
 * parsed, so every piece of text in the app is covered automatically.
 *
 * @param decodedContent - The result of `decodeURIComponent(data-content)`.
 */
export const applyBrandingToContent = (decodedContent: string): string => {
  if (!isMGAdviceBrandingEnabled()) {
    return decodedContent;
  }
  // 1. Replace the specific legal entity first (must come before the general swap)
  const withLimited = decodedContent.replace(/M&G Wealth Advice Limited/g, BRAND_NEW_LIMITED);
  // 2. Replace all remaining general brand name occurrences
  return withLimited.replace(/M&G Wealth Advice/g, BRAND_NEW);
};




// WEBPACK FOOTER //
// ./src/utilities/branding.ts